import React from 'react';
import _ from 'lodash';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import NoResultsErrorState from '@components/Templates/ErrorStates/NoResultsErrorState';
import GenericErrorState from '@components/Templates/ErrorStates/GenericErrorState';

function TemplateGalleryErrorScreen({
  showEmptyError,
  isMobileView,
}: {
  showEmptyError?: boolean;
  isMobileView?: boolean;
}) {
  const { navigate, router } = useShallowRouter();

  const clearAll = () => {
    navigate(
      updateQueryParams({}, router, {
        all: true,
      }),
      false,
    );
    setTimeout(() => window.location.reload(), 0);
  };

  return showEmptyError ? (
    <NoResultsErrorState isMobileView={isMobileView} />
  ) : (
    <GenericErrorState overrideAction={clearAll} />
  );
}

export default TemplateGalleryErrorScreen;
